module.exports = __webpack_public_path__ + "img/online_payments.6a2e1f78.webp";